// extracted by mini-css-extract-plugin
export default {"customer":"tOD6Z2Zw72FYmtK6sa4Wxw==","customerReview":"exQMR-xNR4In97lZicdJlw==","active":"Z3VEK8NSxGg9IFmqwtS5gQ=="};